import clsx from 'clsx';
import React from 'react';
import { polymorphicFactory } from '../../factory/factory.utils.mjs';
import { Box } from '../../Other/Box/Box.mjs';
import { DEFAULT_IMG_PLACEHOLDER } from './Image.constants.mjs';
import { RevealWhenReadyEnhancer } from './RevealWhenReadyEnhancer.mjs';
import { SmartCropS7Enhancer } from './SmartCropS7Enhancer.mjs';

const Image = polymorphicFactory((props, ref) => {
  const {
    component = "img",
    src,
    srcSet,
    alt,
    className,
    width = "100%",
    height = "100%",
    objectFit = "cover",
    position = "relative",
    objectPosition = "center",
    reveal = "default",
    inlineSwap = false,
    placeholderSrc = DEFAULT_IMG_PLACEHOLDER,
    zIndex,
    inset,
    ...rest
  } = props;
  const classNames = clsx("kohler-image-root", className);
  const isSmartCrop = rest["data-mode"] === "smartcrop";
  const renderSrc = reveal === "when-ready" && inlineSwap && placeholderSrc ? placeholderSrc : src;
  const baseImg = /* @__PURE__ */ React.createElement(
    Box,
    {
      className: classNames,
      component,
      ref,
      src: renderSrc,
      srcSet,
      alt,
      position,
      width,
      height,
      zIndex,
      inset,
      objectFit,
      objectPosition,
      ...reveal === "when-ready" && inlineSwap ? { "data-src": src } : {},
      ...rest
    }
  );
  const smart = isSmartCrop ? /* @__PURE__ */ React.createElement(SmartCropS7Enhancer, null, baseImg) : baseImg;
  return reveal === "when-ready" ? /* @__PURE__ */ React.createElement(RevealWhenReadyEnhancer, { style: { zIndex, position, inset } }, smart) : smart;
});

export { Image };
